<template>
  <div>
    <b-row>
      <b-col
        md="6"
        class="d-flex align-items-center align-items-lg-center"
      >
        <label>Show</label>
        <v-select
          v-model="perPage"
          :options="[5, 10, 25]"
          :clearable="false"
          style="width:90px;"
          @input="$emit('new-per-page', $event)"
        />
        <label>entries</label>
      </b-col>
      <b-col
        md="6"
        class="d-flex justify-content-end"
      >
        <b-pagination
          :value="value"
          :total-rows="total"
          :per-page="perPage"
          first-number
          last-number
          class="mb-0 mt-1 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
          @change="$emit('input', $event)"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>

      </b-col>
    </b-row>
  </div>
</template>
<script>
import { BPagination, BRow, BCol } from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BPagination,
    vSelect,
    BRow,
    BCol,
  },
  props: {
    total: {
      type: Number,
      default: 1,
    },
    value: {
      type: Number,
      default: 1,
    },

  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
    }
  },
}
</script>

<style>

</style>
